import americanExpress from './logos/american-express.svg';
import dinersClub from './logos/diners-club-international.svg';
import ideal from './logos/ideal.svg';
import jcb from './logos/jcb.svg';
import mastercard from './logos/mastercard.svg';
import paypalCredit from './logos/paypal-credit.png';
import paypal from './logos/paypal.svg';
import visa from './logos/visa.svg';

export const paymentMethods = [
  {
    src: paypal,
    alt: 'PayPal',
  },
  {
    src: paypalCredit,
    alt: 'PayPal Credit',
  },
  {
    src: mastercard,
    alt: 'Mastercard',
  },
  {
    src: visa,
    alt: 'VISA',
  },
  {
    src: dinersClub,
    alt: 'Diners Club International',
  },
  {
    src: americanExpress,
    alt: 'American Express',
  },
  {
    src: jcb,
    alt: 'JCB',
  },
  {
    src: ideal,
    alt: 'iDeal',
  },
];
